import React from "react";
import { motion } from "framer-motion";
import '../../assets/css/goapackage.css'

const images = [
  "https://images.unsplash.com/photo-1500375592092-40eb2168fd21",
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
  "https://images.unsplash.com/photo-1528127269322-539801943592",
  "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
  "https://images.unsplash.com/photo-1493558103817-58b2924bce98",
  "https://images.unsplash.com/photo-1469474968028-56623f02e42e",
];

export default function GoaPackage() {
  return (
    <section className="goaWrap">

      {/* FLOATING BACKGROUND BLOBS */}
      <div className="bgBlob blob1" />
      <div className="bgBlob blob2" />

      <motion.div
        className="goaCard"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        whileHover={{ scale: 1.02 }}
      >

        {/* IMAGE GRID */}
        <div className="goaImagesGrid">
          {images.map((img, i) => (
            <motion.div
              key={i}
              className="imgBox"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ scale: 1.08, rotate: 1 }}
            >
              <img src={img} alt="Goa" />
            </motion.div>
          ))}
        </div>

        {/* CONTENT */}
        <motion.div
          className="goaContent"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >

          <h2>Goa Group Package</h2>

          <p className="duration">
            Duration: 3 Days / 2 Nights
          </p>

          <div className="includes">
            <h4>Includes:</h4>
            <ul>
              <li>Hotel Stay</li>
              <li>Breakfast</li>
              <li>Beach Activities</li>
              <li>Local Sightseeing</li>
            </ul>
          </div>

          <p className="note">
            Perfect for friends & corporate trips
          </p>

          {/* 🔥 CALL BUTTON ADDED */}
          <motion.a
            href="tel:+91 9699581519"
            className="callBtn"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
          >
            📞 Call to Get Offers
          </motion.a>

        </motion.div>

      </motion.div>

    </section>
  );
}